import { productPrimaryImageStyles as primaryDefaultStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { ButtonProps } from "@insite/mobius/Button";
import { StyledButton } from "@insite/mobius/Clickable";
import { LazyImageStyle } from "@insite/mobius/LazyImage";
import getColor from "@insite/mobius/utilities/getColor";
import { productImageCarouselStyles as carouselDefaultStyles } from "@solveindustrial/Overrides/Components/ProductImageCarousel";
import { productDetailsImageCarouselStyles as carouselStyles } from "@solveindustrial/Overrides/Widgets/ProductDetails/ProductDetailsImageCarousel";
import { primaryImageStyles as primaryStyles } from "@solveindustrial/Overrides/Widgets/ProductDetails/ProductDetailsPrimaryImage";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

primaryStyles.primaryImage = {
    ...primaryStyles.primaryImage,
    centeringWrapper: {
        ...primaryDefaultStyles.centeringWrapper,
        ...primaryStyles.primaryImage?.centeringWrapper,
        css: css`
            ${primaryDefaultStyles.centeringWrapper?.css};
            ${primaryStyles.primaryImage?.centeringWrapper?.css};
            margin: 0;
            min-height: auto;

            img {
                max-height: 380px;
                object-fit: contain;
                aspect-ratio: 1 / 1;
            }

            ${mediaQueriesBP.minMD} {
                height: 380px;
                max-width: 380px;
            }
        `,
    },
};

primaryStyles.imageCarousel = {
    ...primaryStyles.imageCarousel,
    mainContainer: {
        ...primaryStyles.imageCarousel?.mainContainer,
        gap: 0,
        css: css`
            @media screen and (min-width: 386px) {
                min-width: 345px;
            }
        `,
    },
};

const arrowStyle: ButtonProps = {
    variant: "secondary",
    css: css`
        border: 0;
        padding: 0;
        display: inline-flex;
        justify-content: center;
        min-height: auto;
        width: 100%;

        &::after {
            content: none;
        }
    `,
};

carouselDefaultStyles.mainContainer = {
    ...carouselDefaultStyles.mainContainer,
    offsetCss: css`
        align-items: center;
        justify-content: center;
    `,
};

carouselDefaultStyles.prevArrowGridItem = {
    ...carouselDefaultStyles.prevArrowGridItem,
    align: "middle",
    css: css`
        ${carouselDefaultStyles.prevArrowGridItem?.css}
        &[data-axis="y"] {
            justify-content: center;
            max-width: 100%;
            flex: 100%;
            height: 48px;
        }
    `,
};

carouselDefaultStyles.prevArrowButton = {
    ...arrowStyle,
    css: css`
        ${arrowStyle.css}
        ${mediaQueriesBP.minMD} {
            margin: 8px 0 7.5px;
        }
    `,
};

carouselDefaultStyles.carouselGridItem = {
    ...carouselDefaultStyles.carouselGridItem,
    css: css`
        ${carouselDefaultStyles.carouselGridItem?.css}

        &[data-axis="x"] {
            @media screen and (min-width: 386px) {
                max-width: 285px;
                flex: 285px;
            }
        }

        &[data-axis="y"] {
            max-width: 100%;
            flex: 100%;
        }
    `,
};

carouselDefaultStyles.carouselSlidesContainer = {
    ...carouselDefaultStyles.carouselSlidesContainer,
    css: css`
        ${carouselDefaultStyles.carouselSlidesContainer?.css};

        &[data-axis="x"] {
            max-width: 285px;
        }

        &[data-axis="y"] {
            max-height: 558px;
            flex-direction: column;
            margin-top: -5px;
        }
    `,
};

carouselDefaultStyles.carouselSlide = {
    ...carouselDefaultStyles.carouselSlide,
    css: css`
        ${carouselDefaultStyles.carouselSlide?.css};
        display: inline-flex;
        align-items: center;
        justify-content: center;
    `,
};

carouselDefaultStyles.carouselSlideInner = {
    ...carouselDefaultStyles.carouselSlideInner,
    css: css`
        ${carouselDefaultStyles.carouselSlideInner?.css};

        &[data-axis="x"] {
            padding: 0 6px;
        }

        &[data-axis="y"] {
            padding: 7.5px 0;
        }

        & > ${StyledButton} {
            width: 100%;

            & > ${LazyImageStyle} {
                padding-top: calc(100% - 2px);
                position: relative;

                p,
                img {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }
    `,
};

carouselStyles.imageCarousel = {
    ...carouselStyles.imageCarousel,
    mainContainer: {
        ...carouselStyles.imageCarousel?.mainContainer,
        css: css`
            ${mediaQueriesBP.minMD} {
                margin: 20.5px 0;
            }
        `,
    },
};

carouselDefaultStyles.image = {
    ...carouselDefaultStyles.image,
    css: css`
        ${carouselDefaultStyles.image?.css};
        border: 1px solid transparent;
        justify-content: center;
        max-width: 80px;
        max-height: 80px;

        img {
            max-width: 80px;
            max-height: 80px;
        }
    `,
};

carouselDefaultStyles.selectedImage = {
    ...carouselDefaultStyles.selectedImage,
    css: css`
        ${carouselDefaultStyles.selectedImage?.css};
        border: 1px solid ${getColor(colorStrings.primaryMain)};
        max-width: 80px;
        max-height: 80px;
        justify-content: center;

        img {
            max-width: 80px;
            max-height: 80px;
        }
    `,
};

carouselDefaultStyles.nextArrowGridItem = {
    align: "middle",
    css: css`
        ${carouselDefaultStyles.nextArrowGridItem?.css}
        &[data-axis="y"] {
            justify-content: center;
            max-width: 100%;
            flex: 100%;
            height: 48px;
        }
    `,
};

carouselDefaultStyles.nextArrowButton = {
    ...arrowStyle,
    css: css`
        ${arrowStyle.css}
        ${mediaQueriesBP.minMD} {
            margin: 7.5px 0 8px;
        }
    `,
};
